import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import TopBar from './TopBar';
import CartIcon from './CartIcon';

const NAV_LINKS = [
  { path: '/mujer', label: 'Women', testId: 'nav-women' },
  { path: '/hombre', label: 'Men', testId: 'nav-men' },
  { path: '/accesorios', label: 'Accessories', testId: 'nav-accessories' },
  { path: '/gift-cards', label: 'Tarjetas Regalo', testId: 'nav-gift-cards' },
  { path: '/rebajas', label: 'Rebajas', testId: 'nav-sale', sale: true },
];

const MobileMenu = ({ onNavigate, pathname }) => (
  <div className="md:hidden border-t border-neutral-200 bg-white animate-in slide-in-from-top-2 fade-in duration-200" data-testid="mobile-menu">
    {NAV_LINKS.map(({ path, label, testId, sale }) => (
      <button
        key={path}
        onClick={() => onNavigate(path)}
        className={`block w-full text-left px-6 py-4 text-sm font-bold uppercase tracking-[0.15em] border-b border-neutral-100 transition-colors hover:bg-neutral-50 ${sale ? 'text-red-600' : ''} ${pathname === path ? 'bg-neutral-50' : ''}`}
        data-testid={`mobile-${testId}`}
      >
        {label}
      </button>
    ))}
    <button onClick={() => onNavigate('/mi-cuenta')} className="block w-full text-left px-6 py-4 text-xs font-bold uppercase tracking-[0.15em] text-neutral-500 hover:bg-neutral-50" data-testid="mobile-nav-account">
      Mi cuenta
    </button>
  </div>
);

const Header = ({ onCartClick }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => setMenuOpen(false), [pathname]);

  return (
    <>
      <TopBar />
      <nav className="sticky top-0 z-40 bg-white border-b border-neutral-200">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <button
                onClick={() => setMenuOpen((o) => !o)}
                className="md:hidden p-1 -ml-1"
                aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
                data-testid="mobile-menu-toggle"
              >
                {menuOpen ? <X className="w-6 h-6" strokeWidth={1.75} /> : <Menu className="w-6 h-6" strokeWidth={1.75} />}
              </button>
              <button
                onClick={() => navigate('/')}
                className="text-xl sm:text-2xl font-black uppercase tracking-tighter"
                data-testid="nav-logo"
              >
                JRF<span className="text-neutral-400">·</span>Sportswear
              </button>
            </div>

            <div className="hidden md:flex items-center gap-10 text-[12px] font-bold uppercase tracking-[0.15em]">
              {NAV_LINKS.map(({ path, label, testId, sale }) => (
                <button
                  key={path}
                  onClick={() => navigate(path)}
                  className={`py-1 hover:opacity-70 transition-opacity ${sale ? 'text-red-600' : ''} ${
                    pathname === path ? `border-b-2 ${sale ? 'border-red-600' : 'border-black'}` : ''
                  }`}
                  data-testid={testId}
                >
                  {label}
                </button>
              ))}
            </div>

            <CartIcon onClick={onCartClick || (() => navigate('/cart'))} />
          </div>
        </div>
        {menuOpen && <MobileMenu onNavigate={navigate} pathname={pathname} />}
      </nav>
    </>
  );
};

export default Header;
